import PropTypes from "prop-types";
import React from "react";

import CodeMirror from "@uiw/react-codemirror";
import { json } from "@codemirror/lang-json";
import { css } from "@codemirror/lang-css";
import { liquid } from "@codemirror/lang-liquid";
import { graphql } from "cm6-graphql";

const languages = {
  css: css(),
  liquid: liquid(),
  graphql: graphql(),
  json: json(),
};

const CodeEditorField = ({ value, onChange, lang, editable = true }) => (
  <CodeMirror
    value={value}
    height="600px"
    extensions={[languages[lang]]}
    onChange={onChange}
    editable={editable}
  />
);

CodeEditorField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  lang: PropTypes.string.isRequired,
  editable: PropTypes.bool,
};

export default CodeEditorField;
